import {
  AddGiftCardToCartRequestedAction,
  addGiftCardToCartFailed,
  addGiftCardToCartSucceeded
} from '../../carts/cartsSlice';
import {
  ApiAddGiftCardToCartFailedAction,
  ApiAddGiftCardToCartSucceededAction,
  apiAddGiftCardToCartFailedType,
  apiAddGiftCardToCartRequested,
  apiAddGiftCardToCartSucceededType
} from '@spa/lib/store/api/cart/addGiftCardToCartApi';
import { put, race, take } from 'typed-redux-saga';
import { StateGiftCardStatus } from '@spa/lib/store/carts/CartsState';
import convertCartToStateCart from '@spa/lib/converters/convertCartToStateCart';
import convertCurrencyIso from '@spa/lib/converters/convertCurrencyIso';
import generateActionId from '../../../generateActionId';

const convertGiftCardStatus = (
  status: ApiAddGiftCardToCartSucceededAction['payload']['result']['status']
): StateGiftCardStatus => ({
  balance: {
    valueWithTax: status.balance.valueWithTax,
    currencyIso: convertCurrencyIso(status.balance.currencyIso)
  },
  expired: status.expired,
  blocked: status.blocked,
  redeemable: status.redeemable
});

function* addGiftCardToCurrentCartSaga({
  payload: { actionId: requestedActionId, cartId, accountIdentifier, pin }
}: AddGiftCardToCartRequestedAction): Generator {
  const actionId: number = generateActionId();

  yield* put(
    apiAddGiftCardToCartRequested({
      actionId,
      cartId,
      parentActionId: requestedActionId,
      accountIdentifier,
      pin
    })
  );

  let isSameActionId: boolean = false;
  do {
    const { succeeded, failed } = yield* race({
      succeeded: take<ApiAddGiftCardToCartSucceededAction>(apiAddGiftCardToCartSucceededType),
      failed: take<ApiAddGiftCardToCartFailedAction>(apiAddGiftCardToCartFailedType)
    });

    isSameActionId =
      succeeded?.payload.requestedActionId === actionId ||
      failed?.payload.requestedActionId === actionId;

    if (isSameActionId) {
      if (succeeded?.payload?.result) {
        const { cart, status } = succeeded.payload.result;

        yield* put(
          addGiftCardToCartSucceeded({
            cart: cart ? convertCartToStateCart(cart) : null,
            status: convertGiftCardStatus(status),
            onlineId: accountIdentifier,
            requestedActionId
          })
        );
      } else if (failed !== undefined) {
        yield* put(
          addGiftCardToCartFailed({
            requestedActionId,
            errorCode: failed.payload.errorCode
          })
        );
      }
    }
  } while (!isSameActionId);
}

export default addGiftCardToCurrentCartSaga;
